import { CSSObject } from '@chakra-ui/react';

export const StyledDatePicker: CSSObject = {
  '&&&': {
    '.chakra-input, .react-date-picker__wrapper': {
      h: '38px',
      background: 'blackAlpha.400',
      color: 'gamma.200',
      border: 0,
      borderRadius: 'lg',
      transition: 'all .2s ease-in-out',
      fontSize: 'xs',
      px: '2',
      'input, span': {
        fontFamily: 'body',
        fontWeight: 'normal',
      },
      button: {
        color: 'gamma.600',
      },
      boxShadow: 'none',
      _hover: {
        opacity: 0.9,
      },
    },
  },
};
